var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{staticClass:"text-xs-center",attrs:{"rotate":270,"size":28,"width":14,"value":_vm.value,"color":"secondary"}},[_c('span',{staticClass:"body-1 timer-text white--text"},[_vm._v(_vm._s(_vm.second))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503f19a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/countdown.vue
// module id = 1322
// module chunks = 7 8